var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "h-100 d-flex flex-column overflow-y-auto" },
    [
      _c("div", { staticClass: "sidebar-top" }, [
        _c(
          "div",
          { staticClass: "sidebar-item gap-10px flex-column" },
          [
            _c("download-btn"),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex gap-10px flex-wrap" },
              [
                _vm.currentJob.apiJob?.sat?.permissions.can_continue === true
                  ? _c("export-btn")
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentJob.apiJob?.sat?.permissions.can_share === true
                  ? _c("share-btn")
                  : _vm._e(),
                _vm._v(" "),
                _vm.currentJob.apiJob?.sat?.permissions.can_delete === true
                  ? _c("delete-btn")
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.currentJob.state !== "draft"
          ? _c("div", { staticClass: "sidebar-item" }, [_c("job-queued")], 1)
          : _vm._e(),
        _vm._v(" "),
        _vm.currentJob.state !== "not_found"
          ? _c(
              "div",
              { staticClass: "sidebar-item gap-20px flex-column" },
              [_c("current-task")],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.currentJob.state === "processing"
          ? _c(
              "div",
              { staticClass: "sidebar-item gap-20px flex-column" },
              [_c("notify")],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isCreditsInAllSatsEnabled && _vm.currentJob.state === "processing"
          ? _c(
              "div",
              { staticClass: "sidebar-item gap-20px flex-column" },
              [_c("cancel-task")],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.complete === true &&
        _vm.currentJob.apiJob?.sat?.permissions.can_continue === true
          ? _c(
              "div",
              { staticClass: "sidebar-item gap-20px flex-column" },
              [_c("continue-with")],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.resultPage.isMobile === true
          ? _c(
              "div",
              { staticClass: "sidebar-item gap-20px flex-column" },
              [_c("feedback")],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      !_vm.isPremiumUser
        ? _c("div", { staticClass: "sidebar-right-bot-ad" }, [
            _c("div", { staticClass: "d-flex justify-content-center" }, [
              _c("div", { attrs: { id: _vm.adId } }),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }